
export const ACTION_SET_ROUTES = "action-set-routes";
export function actionSetRoutes( routes ) {
    return {
        type: ACTION_SET_ROUTES,
        payload: routes
    }
}


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/actions.js